import { Grid, GridSize, Paper, Typography, Tooltip } from "@mui/material";
import React from "react";
import ItemDetailViewSection, { ItemDetail } from "./ItemDetailViewSection";
import pageStyles from "./../../pages/pageStyles";
import SectionReadForbidden from "../sectionAccess/SectionReadForbidden";

export interface ItemsDetail {
  sectionName: string;
  itemsData?: ItemDetail[];
  isColumn?: boolean;
  lastItem?: boolean;
  col?: GridSize;
  isRestricted?: boolean;
  isSurcharge?: boolean;
}

const ItemsDetailViewSection = (props: ItemsDetail) => {
  const {
    sectionName,
    itemsData,
    isColumn,
    lastItem = false,
    col,
    isRestricted,
    isSurcharge,
  } = props;
  const column = col && typeof col === "number" ? Math.ceil(12 / col) : 12;
  const classes = pageStyles();

  return (
    <Paper
      elevation={0}
      className={classes.sectionWrapper}
      style={{ marginBottom: lastItem ? "0" : "50px" }}
    >
      <Grid
        container
        className={classes.sectionContentWrapper}
        style={{ padding: 0 }}
      >
        <Grid item xs={12} className={classes.sectionHeading}>
          <Typography
            variant="h5"
            display="block"
            className={classes.sectionHeadingTitle}
          >
            {sectionName}
          </Typography>
        </Grid>
        {!isRestricted ? (
          <Grid container spacing={2} className={classes.p15}>
            {itemsData?.length
              ? itemsData?.map((item, idx) => (
                  <Grid key={idx} item xs={12} md={column as GridSize}>
                    <ItemDetailViewSection
                      itemData={item.itemData}
                      additionalData={item.additionalData}
                      sectionName={item.sectionName}
                      isChild
                      isColumn={isColumn}
                      isSurcharge={isSurcharge}
                      isRTL={item.isRTL}
                      bin={item.bin}
                    />
                  </Grid>
                ))
              : "No Data"}
          </Grid>
        ) : (
          <SectionReadForbidden />
        )}
      </Grid>
    </Paper>
  );
};

export default ItemsDetailViewSection;
